import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get flavour
export const getFlavour = createAsyncThunk("flavour/getFlavour", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;

    const { data } = await API.getFlavour({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all flavour
export const getAllFlavour = createAsyncThunk("flavour/getAllFlavour", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllFlavour();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("flavour/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("flavour/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("flavour/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageFlavour({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create flavour
export const createFlavour = createAsyncThunk("flavour/createFlavour", async (data, { rejectWithValue }) => {
  const { name, isActive } = data;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.createFlavour(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateFlavour = createAsyncThunk("flavour/updateFlavour", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, isActive } = values;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.updateFlavour(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("flavour/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
